// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d1d49d9","455":"f816a739","977":"4b442315"}[chunkId] + ".chunk.js";
};